import { ADS_SLIDER } from "../../constants/actionTypes";
import axios from 'axios';

export const addAdsSlider = (token, data) => {
    return (dispatch) => {
        dispatch({ type: ADS_SLIDER.ADD_ADS_SLIDER_REQUEST });
        const AuthStr = 'Bearer '.concat(token);
        const INSTANCE = axios.create({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthStr
            }
        });

        let inputJSON = JSON.stringify(data);
        
        INSTANCE.post("ads-slider/create", inputJSON)
            .then(function (response) {
                dispatch(addAdsSliderSuccess(response.data));
            })
            .catch(function (error) {
                dispatch(addAdsSliderError(error.message));
            });
    };
};

const addAdsSliderSuccess = (data) => ({
    type: ADS_SLIDER.ADD_ADS_SLIDER_SUCCESS,
    payload: data
});

const addAdsSliderError = errorMessage => ({
    type: ADS_SLIDER.ADD_ADS_SLIDER_FAIL,
    payload: errorMessage
});

export const listAdsSlider = (token, data) => {
  return (dispatch) => {
    dispatch({ type: ADS_SLIDER.LIST_ADS_SLIDER_REQUEST });
    const AuthStr = 'Bearer '.concat(token);
    let inputJSON = JSON.stringify(data);
    const INSTANCE = axios.create({
      headers: {
        'Content-Type': 'application/json',
        'Authorization': AuthStr
      }
    });

    INSTANCE.post("ads-slider/lists", inputJSON)
      .then(function (response) {
        dispatch(listAdsSliderSuccess(response.data));
      })
      .catch(function (error) {
        dispatch(listAdsSliderError(error.message));
      });
  };
};

const listAdsSliderSuccess = (data) => ({
    type: ADS_SLIDER.LIST_ADS_SLIDER_SUCCESS,
    payload: data
});

const listAdsSliderError = errorMessage => ({
    type: ADS_SLIDER.LIST_ADS_SLIDER_FAIL,
    payload: errorMessage
});

export const deleteAdsSlider = (token, data) => {
    return (dispatch) => {
        dispatch({ type: ADS_SLIDER.DELETE_ADS_SLIDER_REQUEST });
        const AuthStr = 'Bearer '.concat(token);
        const INSTANCE = axios.create({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthStr
            }
        });

        let inputJSON = JSON.stringify(data);
        
        INSTANCE.post("ads-slider/delete", inputJSON)
            .then(function (response) {
                dispatch(deleteAdsSliderSuccess(response.data));
            })
            .catch(function (error) {
                dispatch(deleteAdsSliderError(error.message));
            });
    };
};

const deleteAdsSliderSuccess = (data) => ({
    type: ADS_SLIDER.DELETE_ADS_SLIDER_SUCCESS,
    payload: data
});

const deleteAdsSliderError = errorMessage => ({
    type: ADS_SLIDER.DELETE_ADS_SLIDER_FAIL,
    payload: errorMessage
});

export const updateAdsSlider = (token, data) => {
    return (dispatch) => {
        dispatch({ type: ADS_SLIDER.UPDATE_ADS_SLIDER_REQUEST });
        const AuthStr = 'Bearer '.concat(token);
        const INSTANCE = axios.create({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthStr
            }
        });

        let inputJSON = JSON.stringify(data);
        
        INSTANCE.post("ads-slider/update", inputJSON)
            .then(function (response) {
                dispatch(updateAdsSliderSuccess(response.data));
            })
            .catch(function (error) {
                dispatch(updateAdsSliderError(error.message));
            });
    };
};

const updateAdsSliderSuccess = (data) => ({
    type: ADS_SLIDER.UPDATE_ADS_SLIDER_SUCCESS,
    payload: data
});

const updateAdsSliderError = errorMessage => ({
    type: ADS_SLIDER.UPDATE_ADS_SLIDER_FAIL,
    payload: errorMessage
});

export const resetAdsSlider = () => {
    return (dispatch) => {
        dispatch({ type: ADS_SLIDER.RESET_ADS_SLIDER})
    }
}
